export default "__VITE_ASSET__jz_rrMHhQF2uXclhGC9bfQ__"